import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-vendor-price-rate-list-details',
  templateUrl: './vendor-price-rate-list-details.component.html',
  styleUrls: ['./vendor-price-rate-list-details.component.scss']
})
export class VendorPriceRateListDetailsComponent implements OnInit, OnChanges {
  @Input() vendorDetails: any;

  vendorDetailList: any = [];

  constructor(
    public vendorService: VendorDashboardService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    // this.loadData();
    // console.log('Initial vendorDetails:', this.vendorDetails);
  }

  loadData() {
    let vendorId = this.vendorDetails?.Vendor_Id;

    this.vendorService.getVendorRegCompDetailsForApproval(vendorId).pipe(first()).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.vendorDetailList = res;
        }
        else {
          this.vendorDetailList = [];
          this.messageService.add({ severity: 'warn', summary: 'No Data Found', detail: 'Vendor Details Not Found' });
        }
      },
      error: (err) => {
        this.vendorDetailList = [];
        this.messageService.add({ severity: 'error', summary: 'Data Error', detail: err });
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.vendorDetailList = [];
    if (changes['vendorDetails']) {
      // console.log('vendorDetails changed:', changes['vendorDetails'].currentValue);
      this.loadData();
    }
  }
}
